export default (): AccordionComponent => {

    return {
        isOpen: false,
        handleToggle() {
            console.log(this.$refs.tab);
            return this.isOpen ? `max-height: ${this.$refs.tab.scrollHeight}px` : 'max-height:0';
        }
    };
};

import {AlpineComponent} from "alpinejs"

type AccordionComponent = AlpineComponent<{
    isOpen: boolean,
    handleToggle: Function
}>
